// eslint-disable-next-line import/no-extraneous-dependencies
import * as Sentry from '@sentry/react';

const isProduction =
  import.meta.env.VITE_NODE_ENV === 'production' || import.meta.env.VITE_REACT_APP_NODE_ENV === 'production';
const isLocalhost =
  import.meta.env.VITE_NODE_ENV === 'localhost' || import.meta.env.VITE_REACT_APP_NODE_ENV === 'localhost';

if (!isLocalhost) {
  Sentry.init({
    ignoreErrors: [
      'ResizeObserver loop limit exceeded',
      'ResizeObserver loop completed with undelivered notifications.',
      '$ is not a defined',
      'window.fetch is not a function',
    ],
    dsn: import.meta.env.VITE_SENTRY_DSN,
    sendDefaultPii: true,
    release: import.meta.env.VITE_SENTRY_RELEASE_VERSION,
    integrations: [
      Sentry.feedbackIntegration({
        colorScheme: 'system',
        showBranding: false,
        messagePlaceholder: 'Please describe the issue in detail',
        id: 'sentry-feedback',
      }),
      Sentry.browserTracingIntegration({
        // Enable tracing for all navigation events
        instrumentNavigation: true,
        // Enable tracing for initial page load
        instrumentPageLoad: true,
        // Set a reasonable idle timeout
        idleTimeout: 1000,
        // Set maximum duration for transactions
        finalTimeout: 30000,
        // Set timeout for child spans
        childSpanTimeout: 15000,
        // Mark spans as cancelled when tab is in background
        markBackgroundSpans: true,
        // Enable long task monitoring
        enableLongTask: true,
        // Enable INP monitoring
        enableInp: true,
        // Filter out health check requests from tracing
        shouldCreateSpanForRequest: (url) => {
          // Don't create spans for health check endpoints
          return !url.includes('/auth/ping');
        },
      }),
      Sentry.replayIntegration(),
    ],
    // Adjust sampling rates based on environment
    tracesSampleRate: isProduction ? 0.1 : 0.05, // 10% in production, 5% in development
    replaysSessionSampleRate: 0, // 0% in production, 0% in development
    replaysOnErrorSampleRate: isProduction ? 1.0 : 0.0, // 100% in production, 0% in development
    environment: import.meta.env.VITE_NODE_ENV || import.meta.env.VITE_REACT_APP_NODE_ENV,

    tracePropagationTargets: ['https://portalapi.stninc.com', 'https://portalapi.lab.stninc.com'],
    _experiments: { enableLogs: true },
  });
}
